import React, { useEffect } from "react";
import {
  isChatbotEnabled,
  openChatbot,
  registerChatbotLauncher,
} from "./chatbot-widget";
import chatIconUrl from "../../public/assets/images/chatbot/falcon-chat-ic.svg";

/*******************
  @Purpose : Chatbot icon button that opens the chatbot widget
  @Parameter : {variant} "floating" - fixed bottom-right round button
                         "inline"   - small chat icon placed inside a page header
               {className} extra classes, e.g. position modifiers
  *******************/
function ChatbotButton({ variant = "floating", className = "" }) {
  useEffect(() => registerChatbotLauncher(), []);

  if (!isChatbotEnabled()) {
    return null;
  }

  const isInline = variant === "inline";
  const variantClass = isInline ? "chatbot-inline-button" : "custom-chatbot-button";

  return (
    <button
      type="button"
      className={`${variantClass} ${className}`.trim()}
      aria-label="Ask Falcon"
      onClick={openChatbot}
    >
      {isInline ? (
        <img src={chatIconUrl} width="24" height="24" alt="" draggable="false" />
      ) : (
        <img
          src="/assets/images/chatbot-button.png"
          width="208"
          height="208"
          alt=""
          draggable="false"
        />
      )}
    </button>
  );
}

export default ChatbotButton;
